import React from "react";
import { Paper, Group, Text, ActionIcon, Stack } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { CopyButton } from "@mantine/core";
import TopRightInfoCircle from "./topRightInfoCircle"; // Adjust the import path if needed

interface KeyDisplayProps {
  contextText: string;
  explanatoryText: string;
  infoLink: string;
}

const KeyDisplay: React.FC<KeyDisplayProps> = ({
  contextText,
  explanatoryText,
  infoLink,
}) => {
  // Show only the first 20 characters of the context text
  const contextTextSnippet = contextText.slice(0, 20);

  return (
    <Paper p="md" withBorder radius="md" style={{ position: "relative" }}>
      {/* <TopRightInfoCircle infoLink={infoLink} /> */}
      <Group pr="sm" justify="flex-start" gap="s">
        <Stack gap="xs">
          <Group gap="xs" align="center">
            <Text size="xs" style={{ wordBreak: "break-all", maxWidth: "80%" }}>
              {contextText}
            </Text>
            <CopyButton value={contextText}>
              {({ copied, copy }) => (
                <ActionIcon
                  size="lg"
                  variant={copied ? "filled" : "default"}
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  aria-label="copy address"
                >
                  {copied ? <IconCheck /> : <IconCopy />}
                </ActionIcon>
              )}
            </CopyButton>
          </Group>
          <Text
            size="xs"
            mt="-.5rem"
            c="dimmed" // Make the text dimmed
          >
            {explanatoryText}
          </Text>
        </Stack>
      </Group>
    </Paper>
  );
};

export default KeyDisplay;
